var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageEditorColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.98665 7.78906C7.0187 7.78906 6.2334 8.57436 6.2334 9.54231C6.2334 10.5103 7.0187 11.2956 7.98665 11.2956C8.95459 11.2956 9.73989 10.5103 9.73989 9.54231C9.73989 8.57436 8.95459 7.78906 7.98665 7.78906Z",
    fill: "#FB4764"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.013 18.7031C21.0451 18.7031 20.2598 19.4884 20.2598 20.4564C20.2598 21.4243 21.0451 22.2096 22.013 22.2096C22.981 22.2096 23.7663 21.4243 23.7663 20.4564C23.7663 19.4884 22.981 18.7031 22.013 18.7031Z",
    fill: "#FB4764"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.221 4.67188C13.2531 4.67188 12.4678 5.45717 12.4678 6.42512C12.4678 7.39307 13.2531 8.17837 14.221 8.17837C15.189 8.17837 15.9743 7.39307 15.9743 6.42512C15.9743 5.45717 15.189 4.67188 14.221 4.67188Z",
    fill: "#FB4764"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4544 6.23438C19.4865 6.23438 18.7012 7.01967 18.7012 7.98762C18.7012 8.95557 19.4865 9.74087 20.4544 9.74087C21.4224 9.74087 22.2077 8.95557 22.2077 7.98762C22.2077 7.01967 21.4224 6.23438 20.4544 6.23438Z",
    fill: "#FB4764"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5716 12.4688C22.6037 12.4688 21.8184 13.254 21.8184 14.222C21.8184 15.1899 22.6037 15.9752 23.5716 15.9752C24.5396 15.9752 25.3249 15.1899 25.3249 14.222C25.3249 13.254 24.5396 12.4688 23.5716 12.4688Z",
    fill: "#FB4764"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 30C13.5207 30 12.4675 28.714 12.4675 27.2742V24.3506C12.4675 20.5854 9.41458 17.5325 5.64935 17.5325H2.72575C1.28603 17.5325 0 16.4793 0 15C0 6.7161 6.7161 0 15 0C23.2839 0 30 6.7161 30 15C30 23.2839 23.2839 30 15 30ZM15 0.38961C6.93078 0.38961 0.38961 6.93078 0.38961 15C0.38961 16.2251 1.46104 17.1429 2.72575 17.1429H5.64935C9.63078 17.1429 12.8571 20.3693 12.8571 24.3506V27.2742C12.8571 28.539 13.7749 29.6104 15 29.6104C23.0692 29.6104 29.6104 23.0692 29.6104 15C29.6104 6.93078 23.0692 0.38961 15 0.38961Z",
    fill: "#FB4764"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageEditorColor);
export default __webpack_public_path__ + "static/media/ImageEditorColor.6fe6170d0a8eecafd8d2ba539ea8b677.svg";
export { ForwardRef as ReactComponent };